/*
 * @Author: panweikang
 * @Date: 2024-01-03 09:34:14
 * @LastEditTime: 2025-09-05 20:01:42
 * @Description:年度报告页面
 */
import './index.scss'
import logo from '../../static/report/logo.png'
import btn from '../../static/report/btn.png'
import selection2023Png from '../../static/YearMiddleReport2024/report/selection2023.png'
import myReportNewPng from '../../static/report/myReportNew.png'
import xiahuaPng from '../../static/report/xiahua.png'
// import reportPng from '../../static/report/report.png'
import React, { useState } from 'react'
import { Swiper, Popup, Toast, SpinLoading } from 'antd-mobile'
import MFooter from '../../components/MFooter/index'
import { useNavigate, useParams } from 'react-router-dom'
import qs from 'qs'
import MVerification from '../../components/MVerification/index'
import { useEffect } from 'react'
import { createPortal } from 'react-dom'
import {
  checkPhoneApi,
  getRegionListApi,
  checkArmouryNumberApi,
  getUserInfoApi,
  checkUserViewReportApi,
} from '../../api/yearEndReportApi'

// import { topicDes, regionImage, topicImage } from './constants'
import wxConfig from '../../utils/wxConfig'
import { yearMiddle2025 } from './constants'

// const ReportMainPage = () => {
//   return (
//     <div className="ReportMainPage">
//       <div className="head">
//         <img src={logo} alt="logo" />
//         <div>
//           <p>本报告由瑞莱博出品</p>
//           <p>
//             值得信赖的仓储及工业设施<span>租售专家</span>
//           </p>
//         </div>
//       </div>
//       <div className="bg"></div>
//       <img src={btn} className="btn" alt="btn" />
//     </div>
//   )
// }

// let topicIndex = 0
// let isLastYear = false

const RegionalSelectionPage = () => {
  let navigate = useNavigate()

  let userInfo = JSON.parse(sessionStorage.getItem('userInfo') ?? '{}')

  useEffect(() => {
    if (!userInfo.openId) {
      Toast.show({
        content: '正在授权中...',
        duration: 0,
        maskClickable: false,
      })
      wxAuthorize()
    } else {
      wxConfig(userInfo.openId)
    }
    init()
  }, [])

  let init = async () => {
    // let res = await getRegionListApi({
    //   year: '2024-H1',
    // })
    // setRegion(res.data)
  }

  // 微信授权
  let wxAuthorize = async () => {
    const params = qs.parse(window.location.href.split('?')[1])
    if (!params.code) {
      // let shareOpenId = params.shareOpenId ?? ''
      // console.log('shareOpenId(code不存在的情况)', shareOpenId)
      let appid = 'wxc005ab723cf1e525'
      let redirect_uri = window.location.origin + '/rlb/YearMiddleReport2025'
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=&forcePopup=true#wechat_redirect`
      return Promise.reject('跳转了')
    } else {
      console.log('code：', params.code)
      // http://localhost:3000/rlb/YearEndReport/0?code=031G2HFa1WCwHG02fpFa1iyLRA1G2HFY&state=o5u_6sl6MooG9dj0xGDC_zqwWExc
      // let shareOpenId = params.state ?? '' // 分享者的openid
      // console.log('shareOpenId', shareOpenId)
      console.log(`code---准备调用/user-empower`)
      let res = await getUserInfoApi({
        code: params.code,
        openId: '',
        // openId: shareOpenId,
      })
      if (res.status === 200) {
        // setUserInfo(res.data)
        if (res.data.openId === '') {
          Toast.show('请授权体验完整服务')
          return
        }
        userInfo = res.data
        sessionStorage.setItem('userInfo', JSON.stringify(res.data))
        wxConfig(userInfo.openId)
        Toast.clear()
      }
      return Promise.resolve({
        ...res.data,
      })
    }
  }

  // 大区
  // let [region, setRegion] = useState([])
  // let regionImg = [selection1Png, selection2Png, selection3Png, selection4Png]
  // let [regionIndex, setRegionIndex] = useState(0)

  // 话题
  // let [topic, setTopic] = useState([])
  // let [topicIndex, setTopicIndex] = useState(0)

  // let topicImg = [...topicImage]

  // let openPopup = (item, index) => {
  //   setTopic(item.topics)
  //   setRegionIndex(index)
  //   setVisible(true)
  // }

  let goDetail = async (item) => {
    if (item.isRoute) {
      navigate(item.url)
    } else {
      window.open(item.url, '_blank')
    }
  }

  return (
    <div className="RegionalSelectionPage">
      <div className="head">
        <img src={logo} alt="logo" />
        <div>
          <p>本报告由瑞莱博出品</p>
          <p>
            值得信赖的仓储及工业设施<span>租售专家</span>
          </p>
        </div>
        {/* <div onClick={goMineReport}>
          <img src={myReportPng} alt="myReportPng" />
          <p>我的报告</p>
        </div> */}
      </div>

      {yearMiddle2025.map((item, index) => {
        return (
          <img
            key={index}
            className="selection"
            src={item.coverImage}
            alt={item.regionName}
            onClick={() => {
              goDetail(item)
            }}
          />
        )
      })}

      <MFooter />
      {/* <Popup
        visible={visible}
        onMaskClick={() => {
          setVisible(false)
        }}
        onClose={() => {
          setVisible(false)
        }}
        bodyStyle={{
          borderTopLeftRadius: '8px',
          borderTopRightRadius: '8px',
        }}
      >
        <div className="typePopup">
          <div className="typePopupHead border">
            <p>您想深入了解{topic && region[regionIndex]?.regionName}哪个话题？</p>
            <span>仅有一次免费查看报告的机会，好友助力或付费可查看更多</span>
          </div>
          {topic.map((item, index) => {
            return (
              <div
                className={topic.length - 1 == index ? 'item' : 'item border'}
                onClick={() => {
                  goDetail(index)
                }}
                key={item.topicId}
              >
                <img src={topicImg[index]} alt={index} />
                <div>
                  <h6>{item.topicName}</h6>
                  <p>{topicDes[item.topicId]}</p>
                </div>
              </div>
            )
          })}
        </div>
      </Popup>
      {createPortal(
        <MVerification
          visible={verificationVisible}
          onSuccess={verificationSuccess}
          onClose={() => {
            setVerificationVisible(false)
          }}
        />,
        document.body
      )} */}
    </div>
  )
}

let YearEndReport = () => {
  // document.title = '2023下半年度高标仓市场'
  document.title = '瑞莱博2025上半年度高标仓市场'
  let navigate = useNavigate()
  const { type } = useParams()
  let [index, setIndex] = useState(type)
  let [allowTouchMove, setAllowTouchMove] = useState(true)
  let onIndexChange = (index) => {
    setIndex(index)
    // setAllowTouchMove(false)
  }
  let goMineReport = async () => {
    navigate('/rlb/YearEndReport/mineReport')
  }

  return (
    <div className="YearEndReport page">
      <Swiper
        allowTouchMove={allowTouchMove}
        defaultIndex={type}
        onIndexChange={onIndexChange}
        indicator={() => null}
      >
        {/* <Swiper.Item>
          <ReportMainPage />
        </Swiper.Item> */}
        <Swiper.Item>
          <RegionalSelectionPage />
        </Swiper.Item>
      </Swiper>
      {index == 1 && (
        <img
          className="myReport"
          src={myReportNewPng}
          alt="myReportNewPng"
          onClick={goMineReport}
        />
      )}
      {index == 1 && <img className="xiahuaImg" src={xiahuaPng} alt="xiahuaPng" />}
    </div>
  )
}

export default YearEndReport
